import React from 'react'
import PropTypes from "prop-types";


const SEO = ({title}) => {
    document.title = title + " | Software & IT Solutions Company"
    return ('');
}
SEO.propTypes = {
    title: PropTypes.string
};

export default SEO;


